import React from "react";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import Bolt from "@/components/Bolt";
import { useT } from "@/lib/i18n";

const MAP_URL =
  "https://static.prod-images.emergentagent.com/jobs/c2604f62-1402-40df-b2da-e4ab3cce9288/images/64bda3e8e147c44eb86e63c7d5b814b909e1b373e8c2e87b4042d265b7e727dd.png";

const BENEFITS = [
  "German customs expertise & FRA hub access",
  "DDP & Importer of Record under one entity",
  "Amazon FBA prep + delivery to EU FCs",
  "Bonded warehousing for duty deferral",
  "Exhibition & ATA Carnet handling",
  "Final-mile parcel delivery across EU",
];

export default function IndiaEurope() {
  const { t } = useT();
  return (
    <section data-testid="india-europe" className="relative py-24 sm:py-28 zp-band-soft border-y border-[color:var(--zp-border)] overflow-hidden">
      <Bolt
        size={420}
        color="#5CE1E6"
        className="absolute -left-20 top-1/2 -translate-y-1/2 pointer-events-none"
        style={{ opacity: 0.07, transform: "translateY(-50%) rotate(-12deg)" }}
      />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="zp-label">{t("ie.eyebrow")}</div>
            <h2 className="font-display text-3xl sm:text-5xl tracking-tighter mt-3 leading-[1.05]">
              {t("ie.title.a")}{" "}
              <span className="zp-cyan-text">{t("ie.title.b")}</span>{" "}
              <span className="text-[color:var(--zp-text-3)]">{t("ie.title.c")}</span>
            </h2>
            <p className="text-[color:var(--zp-text-2)] mt-6 leading-relaxed">
              {t("ie.subtitle")}
            </p>

            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-2.5 text-sm text-[color:var(--zp-navy)]">
                  <CheckCircle2 size={16} className="text-[color:var(--zp-cyan-3)] mt-0.5 shrink-0" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8">
              <Link to="/quote" data-testid="india-europe-cta" className="zp-btn-primary">
                {t("ie.cta")} <ArrowRight size={16} />
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7 relative">
            <div className="absolute -inset-10 bg-gradient-to-br from-[#5CE1E6]/30 via-transparent to-transparent blur-3xl pointer-events-none" />
            <div className="relative rounded-2xl border border-[color:var(--zp-border)] overflow-hidden bg-white shadow-[0_20px_50px_-30px_rgba(10,37,64,0.22)]">
              <img
                src={MAP_URL}
                alt="India to Europe logistics network"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white/40 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 flex flex-wrap gap-2">
                {["BOM → FRA", "DEL → FRA", "MAA → AMS", "BLR → MUC", "HYD → CDG"].map((r) => (
                  <span key={r} className="zp-pill">{r}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
